module.exports = __webpack_public_path__ + "static/media/about img3.fcef5d6a.webp";